import { useLocation } from 'react-router-dom';

import useUserStore from 'store/user.store.ts';
import { checkUserPermission } from '@common/auth';
import { SidebarPaths } from '@components';
import { useMediaQuery } from '@mui/material';
import useSidebarStore from '../../../store/sideBarStore.store.ts';
import { useEffect } from 'react';

const isOptionFocused = (pathname: string) => (option: SidebarPaths) => {
  switch (option) {
    case '/admin':
      return pathname.includes('/admin');
    case '/patient':
      return pathname.includes('/patient');
    case '/worklist':
      return pathname.includes('/worklist');
    case '/dashboard':
      return pathname.includes('/dashboard');
    case '/data-analysis':
      return pathname.includes('/data-analysis');
    case '/reporting':
      return pathname.includes('/reporting');
    case '/activity-logs':
      return pathname.includes('/activity-logs');
    case '/time-off':
      return pathname.includes('/time-off');
    case '/downloads':
      return pathname.includes('/downloads');
    default:
      return false;
  }
};

export const useSidebar = () => {
  const { pathname } = useLocation();
  const { user } = useUserStore();
  const hasAdminPanelPermission = checkUserPermission(user, 'view_admin_panel');
  const isSMSizeDP = useMediaQuery('(max-width: 1535px)');
  const { isSidebarOpen, setIsSidebarOpen } = useSidebarStore();

  const isOptionFocusedCurried = isOptionFocused(pathname);

  const handleDrawerToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    if (isSMSizeDP) {
      setIsSidebarOpen(false);
    }
  }, []);

  return {
    isOptionFocused: isOptionFocusedCurried,
    isSidebarOpen,
    handleDrawerToggle,
    hasAdminPanelPermission,
    userPermissions: user?.permissions ?? [],
    isSMSizeDP,
  };
};
